'use client'

/* eslint-disable import/no-absolute-path */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'
import NewCarsIcon from '@public/images/ackodrive-newCars.svg'
import ExpressDeliveryIcon from '@public/images/ackodrive-express.svg'
import HotDealIcon from '@public/images/ackodrive-hotDeal.svg'
import ElectricVehicleIcon from '@public/images/ackodrive-electricVehicle.svg'
import ArticleIcon from '@public/images/ackodrive-articles.svg'

import CarReviews from '@public/images/ackodrive-carReviews.svg'
import StoriesNews from '@public/images/ackodrive-storiesNews.svg'

export const StyledArticlesIcon = styled(ArticleIcon)`
  width: 22px;
  height: 22px;
`

export const StyledCarReviews = styled(CarReviews)`
  width: 22px;
  height: 22px;
`

export const StyledStoriesNews = styled(StoriesNews)`
  width: 22px;
  height: 22px;
`

export const StyledNewCarsIcon = styled(NewCarsIcon)`
  width: 22px;
  height: 22px;

  path:first-child {
    stroke: #36354c;
  }
  path:last-child {
    fill: #36354c;
  }
`

export const StyledExpressDeliveryIcon = styled(ExpressDeliveryIcon)`
  width: 22px;
  height: 22px;

  path:first-child {
    stroke: #040222;
  }
  path:last-child {
    fill: #040222;
  }
`

export const StyledHotDealIcon = styled(HotDealIcon)`
  width: 22px;
  height: 22px;

  path:last-child {
    fill: #040222;
  }
`

export const StyledElectricVehicleIcon = styled(ElectricVehicleIcon)`
  width: 22px;
  height: 22px;

  path:first-child {
    stroke: #394a64;
  }
  path:last-child {
    fill: #394a64;
  }
`

export const HEADER_MENU = {
  HOME: 'HOME',
  BUY_NEW_CAR: 'BUY NEW CAR',
  BLOG: 'BLOG',
}

export const HEADER_SUBMENU = {
  BUY_NEW_CAR: [
    {
      title: 'NEW CARS',
      url: null,
      icon: <StyledNewCarsIcon />,
      backgroundcolor: '#E7E7F0',
    },
    {
      title: 'EXPRESS DELIVERY',
      url: '/collection/express-delivery-cars/',
      icon: <StyledExpressDeliveryIcon />,
      backgroundcolor: '#D0BDF4',
      eventName: 'tap_btn_collection_menu',
      collectionName: 'express_delivery_cars',
    },
    {
      title: 'HOT DEALS',
      url: '/collection/car-offers/',
      icon: <StyledHotDealIcon />,
      backgroundcolor: '#FFC400',
      eventName: 'tap_btn_collection_menu',
      collectionName: 'hot_deal_cars',
    },
    {
      title: 'ELECTRIC VEHICLES',
      url: '/collection/electric-cars/',
      icon: <StyledElectricVehicleIcon />,
      backgroundcolor: '#8CE99A',
      eventName: 'tap_btn_collection_menu',
      collectionName: 'electric_cars',
    },
  ],
  BLOG: [
    {
      title: 'TOP STORIES AND NEWS',
      url: '/news/',
      icon: <StyledStoriesNews />,
      backgroundcolor: '#F0F0F6',
      eventName: 'tap_btn_news',
    },
    {
      title: 'CAR & BIKE REVIEWS',
      url: '/reviews/',
      icon: <StyledCarReviews />,
      backgroundcolor: '#F0F0F6',
      eventName: 'tap_btn_reviews',
    },
    {
      title: 'INTERESTING ARTICLES',
      url: '/articles/',
      icon: <StyledArticlesIcon />,
      backgroundcolor: '#F0F0F6',
      eventName: 'tap_btn_articles',
    },
  ],
}
